import { Component, OnInit, Output, EventEmitter, Input, OnDestroy, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';

import { UserServiceAccountList } from '@app/shared/models';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { takeUntil, Subject } from 'rxjs';
import { CryptocurrencyAdditionalDataType } from '@app/shared/types';
import { WalletAddressValidator } from '@app/shared/directives/wallet-address-validator.directive';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';

@Component({
    selector: 'tc-request-select-service-number',
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatRadioModule
    ],
    templateUrl: './request-select-service-number.component.html',
    styleUrls: ['./request-select-service-number.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RequestSelectServiceNumberComponent implements OnInit, OnDestroy {
  @Output() accountNumberEmit = new EventEmitter<string>();
  @Output() additionalDataEmit = new EventEmitter<string>();
  @Output() isThirdPartyEmit = new EventEmitter<boolean>();
  @Input() userServiceAccounts: UserServiceAccountList[];
  @Input() isCryptoPage: boolean;
  @Input() additionalDataType: CryptocurrencyAdditionalDataType;
  @Input() canSendThirdParty: boolean = true;
  unsubscribeAll$ = new Subject<void>();

  form: FormGroup;
  isThirdParty = false;

  // types
  additionalDataTypes = CryptocurrencyAdditionalDataType;

  constructor(
    private fb: FormBuilder,
    private cdRef: ChangeDetectorRef
  ) {
  }

  /*******************************************************************
    Lifecycle Hook
  *******************************************************************/
  ngOnInit() {

    this.initForm();
    this.onRecieverAccountChange();
    this.onAddtionalDataChange();

  }

  ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }

  /*******************************************************************
    Form
  *******************************************************************/

  initForm(): void {
    this.form = this.fb.group({
      userAccountNumber: [''],
      recieverAccountNumber: [''],
      addtionalData: ['']
    });
    this.enableSelectUserAccount();
  }

  get f(): any {
    return this.form.controls;
  }

  private enableSelectUserAccount(): void {
    this.f.userAccountNumber.enable();
    this.f.recieverAccountNumber.clearValidators();
    this.f.recieverAccountNumber.disable();
    this.f.recieverAccountNumber.updateValueAndValidity();
    this.f.addtionalData.disable();
  }

  private enableRecieverAccount(): void {
    this.f.userAccountNumber.disable();
    this.f.recieverAccountNumber.enable();
    this.f.addtionalData.enable();
    this.f.recieverAccountNumber.setValidators([WalletAddressValidator()]);
  }

  /*******************************************************************
    General
  *******************************************************************/
  onRecieverAccountChange(): void {
    this.f.recieverAccountNumber.valueChanges
      .pipe(
        takeUntil(this.unsubscribeAll$)
      )
      .subscribe(
        res => {
          if (this.isThirdParty) {
            if (this.f.recieverAccountNumber.hasError('walletAddressValidator')) {
              this.accountNumberEmit.emit('');
              this.isThirdPartyEmit.emit(this.isThirdParty);
              return;
            }
            this.accountNumberEmit.emit(this.f.recieverAccountNumber.value);
            this.isThirdPartyEmit.emit(this.isThirdParty);
          }
        }
      );
  }

  onAddtionalDataChange(): void {
    if (!this.isCryptoPage) {
      return;
    }
    this.f.addtionalData.valueChanges
      .pipe(
        takeUntil(this.unsubscribeAll$)
      )
      .subscribe(
        res => {
          if (this.isThirdParty) {
            this.additionalDataEmit.emit(this.f.addtionalData.value);
            this.isThirdPartyEmit.emit(this.isThirdParty);
          }
        }
      );
    this.cdRef.detectChanges();
  }

  onSelectedUserAccountChange(): void {
    if (!this.isThirdParty) {
      this.accountNumberEmit.emit(this.f.userAccountNumber.value);
      this.isThirdPartyEmit.emit(this.isThirdParty);
    }
  }

  onChangeReceiverType(): void {
    this.isThirdParty = !this.isThirdParty;
    if (this.isThirdParty) {
      this.enableRecieverAccount();
      this.accountNumberEmit.emit(this.f.recieverAccountNumber.value);
      this.isThirdPartyEmit.emit(this.isThirdParty);
    } else {
      this.enableSelectUserAccount();
      this.accountNumberEmit.emit(this.f.userAccountNumber.value);
      this.isThirdPartyEmit.emit(this.isThirdParty);
    }
  }



}
